module.exports = __webpack_public_path__ + "static/media/icon-marker-orange.f7b81029.svg";